{
	"meta": {
		"title": "Careers — UpSquad",
		"description": "Join UpSquad — we're hiring engineers, designers and operators rebuilding what community software should be."
	},
	"hero": {
		"eyebrow": "Careers",
		"title": "Build the future of",
		"title_accent": "community software.",
		"subtitle": "Small, focused team. Big, ambitious mission. Remote-first, hubs in Memphis and New York."
	},
	"perks": {
		"remote": {
			"title": "Remote-first",
			"body": "Work from anywhere"
		},
		"equity": {
			"title": "Equity for all",
			"body": "Real upside, day one"
		},
		"learning": {
			"title": "Learning budget",
			"body": "Books, courses, events"
		},
		"async": {
			"title": "Async-first",
			"body": "Deep work, less noise"
		}
	},
	"culture": {
		"title": "How we",
		"title_accent": "work.",
		"items": {
			"async": {
				"title": "Async & remote",
				"description": "Deep-work mornings, ceremony-light afternoons, async-first communication."
			},
			"ownership": {
				"title": "Ownership over politics",
				"description": "We hire senior, share context, and let people own outcomes end-to-end."
			},
			"craft": {
				"title": "Craft over speed",
				"description": "We ship fast — but never at the expense of quality. The bar is high, on purpose."
			},
			"learning": {
				"title": "Learning budget",
				"description": "Books, courses, conferences. We invest in our team because they invest in the product."
			}
		}
	},
	"openings": {
		"title": "Open positions",
		"empty_title": "No open positions right now",
		"empty_subtitle": "We're always interested in talented people. Drop us a line and we'll keep your CV on file.",
		"empty_cta": "Send your CV"
	}
}
